import { orchestrator } from 'satcheljs';
import { onFilterChanged } from '../actions/onFilterChanged';
import { removeFilter } from '../actions/removeFilter';

orchestrator(removeFilter, actionMessage => {
    onFilterChanged(actionMessage.currentFilters);
});
